const NAV_ROUTES = {
  AUTH: '/auth',
  AUTH_REDIRECT: '/callback',
  USER_MANAGEMENT: '/user-management',
  DASHBOARD_REQUESTS: '/dashboard-requests',
  DASHBOARD: '/dashboard',
  DASHBOARD_MODULE: '/dashboard/:module',
  DASHBOARD_MODULE_SUBMODULE: '/dashboard/:module/:submodule',
  DASHBOARD_MODULE_SUBMODULE_ID: '/dashboard/:module/:submodule/:id',
  HOME: '/home',
  ERROR: '/server-error',
  FEEDBACK: '/feedback',
  NOTIFICATIONS: '/notifications',
  PAGE_NOT_FOUND: '/page-not-found',
  FUNDING_CALCULATOR: '/estimate-facility-size',
  FUNDING_CALCULATOR_PLAYGROUND: '/funding-calculator',
  FUNDING_CALCULATOR_DETAILS: '/funding-calculator/details',
  FUNDING_CALCULATOR_DETAILS_ID: '/funding-calculator/details/:calculationId',
  SIGNUP: '/sign-up',
  DEMO_SIGNUP: '/sign-up/demo',
  DEEP_LINK_REDIRECT: '/redirect',
  GETTING_STARTED: '/dashboard/getting-started',
  DEALS: '/deal-setup',
  REFERRER: '/referrer-setup',
  ACCESS_PENDING: '/access/pending',
  ACCESS_COMPANY_PENDING: '/access/company-pending',
  ACCESS_REJECTED: '/access/rejected',
  ACCESS_INVITATION_EXPIRED: '/access/invitation-expired',
  ACCESS_INVITATION_INVALID: '/access/invitation-invalid',

  // Share routes - all follow pattern /{dashboard-type}/:inviteId
  SHARE_INVESTOR_REPORT: '/investor-report/:inviteId',
};

const PAGE_TITLES = {
  AUTH: 'PvX | Login',
  AUTH_REDIRECT: 'PvX | Login',
  DEEP_LINK_REDIRECT: 'PvX | Login',
  USER_MANAGEMENT: 'PvX | Users',
  DASHBOARD: 'PvX | Dashboards',
  DASHBOARD_MODULE: 'PvX | Dashboards',
  DASHBOARD_MODULE_SUBMODULE: 'PvX | Dashboards',
  HOME: 'PvX | Home',
  ERROR: 'PvX | Error',
  PAGE_NOT_FOUND: 'PvX | Page Not Found',
  FUNDING_CALCULATOR: 'PvX | Funding Calculator',
  FUNDING_CALCULATOR_PLAYGROUND: 'PvX | Funding Calculator',
  FUNDING_CALCULATOR_DETAILS: 'PvX | Funding Calculator',
  FUNDING_CALCULATOR_DETAILS_ID: 'PvX | Funding Calculator',
  FEEDBACK: 'PvX | Feedback',
};

export { NAV_ROUTES, PAGE_TITLES };
